const LeaderboardVolumeHeader: React.FC = () => (
    <div className='row header'>
        <div className='table-header'>Rank</div>
        <div className='table-header'>User</div>
        <div className='table-header'>Win</div>
        <div className='table-header'>Loss</div>
        <div className='table-header'>Collateral</div>
        <div className='table-header'>Volume</div>
    </div>
);

export default LeaderboardVolumeHeader;
